import { render, staticRenderFns } from "./uploadreport.vue?vue&type=template&id=4506201d&"
import script from "./uploadreport.vue?vue&type=script&lang=js&"
export * from "./uploadreport.vue?vue&type=script&lang=js&"
import style0 from "./uploadreport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports